export const tradingContest = {
    cyjyds: "Ikuti Kontes Trading",
    jsjxmh: "Buka Kotak Kejutan, Menangkan Hadiah Super!",
    hdsj: "Waktu Acara",
    mrjxsj: "Berlangsung setiap hari dari 00:00 hingga 23:59 UTC+8.",
    ckxxgz: "Lihat Aturan Detail",
    wdjj: "Hadiah Saya",
    jlkj: "Menuju Pengundian",
    cjjc: "Hadiah Super",
    jjmrzj: "Hadiah Terakumulasi Setiap Hari",
    kqxjd: "Mulai Fase Baru, Jumlah Hadiah Bertambah",
    dyjd: "Fase Pertama",
    dejd: "Fase Kedua",
    dsjd: "Fase Ketiga",
    dsijd: "Fase Keempat",
    jrmhjj: "Hadiah Kotak Kejutan Hari Ini",
    syjj: "Hadiah Tersisa",
    yblqje: "Jumlah yang Telah Diklaim",
    tjmh: "Kotak Kejutan Spesial",
    yjmh: "Kotak Kejutan Level 1",
    ejmh: "Kotak Kejutan Level 2",
    sjmh: "Kotak Kejutan Level 3",
    jj: "Hadiah:",
    gs: "buah",
    djdkrymh: "Klik untuk membuka salah satu kotak kejutan",
    kydk: "Anda dapat membuka",
    jxmh: "Kotak Kejutan",
    dkmhxyxx: "Membuka satu kotak membutuhkan {amount} bintang.",
    xzyyxx: "Anda saat ini memiliki {amount} bintang",
    xxqlsj: "Waktu Reset Bintang: {date} (Harap klaim kotak sebelum bintang direset)",
    wdxx: "Bintang Saya",
    xxhq: "Perolehan Bintang",
    hqxxtj: "Cara Mendapatkan Bintang",
    yxhysxf: "Kontrak Perpetual: Dapat 1 bintang per {amount}U biaya transaksi",
    qqhysxf: "Kontrak Opsi: Dapat 1 bintang per {amount}U volume trading",
    youxihysxf: "GameFi: Dapat 1 bintang per {amount}U volume trading",
    gxhd: "Selamat! Anda telah mendapatkan",
    jlydrzh: "Hadiah ini telah dikirim ke '{account}' Anda",
    qzjzhck: "Lihat di Akun GameFi",
    bwcjjc: "Hadiah Super Biking",
    qmxjyds: "Kontes Trading All-Star",
    gbgbyb: "Berani mencoba?",
    bwcjjcdnn: "Hadiah Super Biking, dapatkan hadiah kotak {amount}% setiap hari!",
    cjjcqmxjys: "Hadiah Super Kontes Trading All-Star Biking {amount}% ditambah kotak setiap hari,",
    syyxbd: "Buka sekali, menang besar dengan modal kecil!",
    zgtk: "Ingin jadi yang teratas? Adu ketangkasan!",
    zhyz: "Hadiah harian {amount}% terakumulasi hingga pertarungan terakhir,",
    dfdj: "Siapa yang akan merebut hadiah puncak Biking?",
    gsjj: "Hadiah Super Kontes Trading All-Star Biking diisi para ahli,",
    qmxpk: "All-Star PK tentukan pemenang!",
    jymh: "Trading, kotak kejutan, peringkat, mainkan arena Biking!",
    zzbzy: "Kontrak perpetual, opsi, GameFi, trading spot, empat minggu permainan yang terus meningkat, berbeda setiap minggu!",
    jlfh: "Hadiah Super Kontes Trading All-Star Biking, hadiah melimpah menunggu Anda meraih nama dan keuntungan, jadi pahlawan dan raja!",
    mh: "Kotak Kejutan",
    cb: "Kejar Peringkat",
    jy: "Trading",
    syxxs: "Jumlah Bintang Tersisa",
    xxbhs: "Perubahan Jumlah Bintang",
    sjlx: "Tipe Peristiwa",
    jycp: "Produk Trading",
    jye: "Volume Trading",
    myxgjl: "Anda belum mendapatkan hadiah terkait",
    jyhd: "Dapat dari Trading",
    ql: "Reset",
    kqmh: "Buka Kotak Kejutan",
    yx: "Game GameFi",
    bchdyjs: "Acara ini telah berakhir",
    gffjj: "Total hadiah yang dibagikan dalam kontes ini",
    kqmhsl: "Jumlah Kotak Kejutan Dibuka",
    cjjcjj: "Hadiah Super",
    cjjchjmd: "Daftar Pemenang Hadiah Super",
    jjdyyh: "Hadiah telah dikirim ke akun dana pengguna",
    hdjj: "Hadiah yang Diterima",
    wff: "Belum Dibagikan",
    mhhjjl: "Catatan Kemenangan Kotak Kejutan",
    cjdjhjjl: "Catatan Kemenangan Hadiah Super",
    jjse: "Jumlah Hadiah",
    xhxxs: "Jumlah Bintang Dihabiskan",
    bwqmxgz: "Aturan Acara Kontes Trading All-Star Biking",
    hdnr: "Konten Acara",
    hdnrgz: "Kontes Trading All-Star Hadiah Super Biking mencakup empat bidang: kontrak perpetual, kontrak opsi, game GameFi, dan trading spot. Acara dibagi menjadi empat minggu, setiap minggu secara bertahap membuka produk trading baru, memungkinkan Anda mendapatkan 'bintang' dan memenangkan hadiah melimpah dalam tantangan trading multidimensi. Hadiah harian {total}% digunakan untuk undian kotak kejutan, hadiah kejutan langsung didapat! Sisa {amount}% terakumulasi hingga akhir kontes, dibagikan berdasarkan peringkat trading untuk hadiah tertinggi!",
    hdjd: "Tahapan Acara",
    jbjs: "Dibuka bertahap, empat periode kompetisi yang meningkat",
    dyzq: "Periode Pertama",
    kqyxhy: "Buka trading kontrak perpetual, semakin tinggi volume trading, semakin banyak poin bintang, semakin tinggi hadiah!",
    dezq: "Periode Kedua",
    jmqqjy: "Tambahkan trading kontrak opsi, untung rugi trading menambah hadiah, tingkatkan jumlah bintang Anda lagi.",
    dszq: "Periode Ketiga",
    cjgejc: "Gabung game GameFi, dapatkan bintang melalui pengalaman trading多元, kejar hadiah besar.",
    dsizq: "Periode Keempat",
    gfzzdj: "Hadiah kotak kejutan tiga minggu pertama terus dibuka, papan peringkat trading spot dibentuk terpisah, bagikan hadiah akhir!",
    jzszjs: "Perhitungan Nilai Hadiah",
    jxmhgz1: "Hadiah harian {amount}% dialokasikan ke kotak kejutan, 100 kotak langsung dibuka dan diklaim, empat level hadiah membuat Anda selalu merasakan kejutan. Hadiah yang tidak diklaim otomatis terakumulasi ke hadiah hari berikutnya, membuat keuntungan terus tumbuh! Kotak spesial, kotak level 1, dll. diperbarui setiap hari, tingkat kemenangan tinggi menunggu Anda buka!",
    mhfpmx: "Total kotak harian {total} buah, total占比 hadiah {amount}%. Detail alokasi kotak:",
    tjmhzb: "Kotak spesial {total} buah,占比 {amount}% hadiah",
    yjmhzb: "Kotak level 1 {total} buah,占比 {amount}% hadiah",
    ejmhzb: "Kotak level 2 {total} buah,占比 {amount}% hadiah",
    sjmhzb: "Kotak level 3 {total} buah,占比 {amount}% hadiah",
    kmhxxyq: "Kebutuhan bintang untuk membuka kotak: Jumlah hadiah kotak harian / {text}",
    tips: "Catatan: Semua hadiah kotak kejutan diperbarui setiap hari pukul 0:00, dihitung ulang berdasarkan hadiah untung/rugi trading setiap produk dari hari sebelumnya + sisa jumlah kotak yang dibuka hari sebelumnya, dialokasikan ke kotak hari ini sesuai level dan rasio di atas.",
    mrjyyk: "Total hadiah berdasarkan untung/rugi trading harian kontrak perpetual, kontrak opsi, GameFi.",
    mgyld: "Setiap order untung {amount}% = jumlah untung * {amount}%",
    mrjcljdjs: "Hadiah harian {amount}% terakumulasi hingga akhir acara, dibagikan kepada tiga teratas papan peringkat empat produk trading, dengan rasio hadiah yang berlanjut: kontrak perpetual 40%, opsi 30%, GameFi 20%, spot 10%.",
    yhhyyld: "Contoh: Order kontrak pengguna untung 1000U, maka 1000*{amount}%={total}U masuk hadiah hari itu",
    mgksd: "Setiap order rugi {amount}%= jumlah rugi aktual (rugi - penutupan rugi) * {amount}%",
    yhhyks: "Contoh: Order kontrak pengguna rugi aktual 1000U, maka 1000*{amount}%={total}U masuk hadiah hari itu",
    qqhyyld: "Setiap order untung {amount}% = jumlah taruhan * odds * {amount}%",
    qqyhddtz: "Contoh: Pengguna bertaruh 100U pada order opsi, untung dalam periode 10 detik, maka 100*65%*{amount}%={total}U masuk hadiah hari itu",
    qqhyksd: "Setiap order rugi {amount}%= jumlah rugi * {amount}%",
    yhksjrjc: "Contoh: Order opsi pengguna rugi 100U, maka 100*{amount}%={total}U masuk hadiah hari itu",
    yxyld: "Setiap order untung {amount}% = jumlah taruhan * odds * {amount}%",
    yxddtz: "Contoh: Pengguna bertaruh 100U pada order gamefi, asumsikan odds 2x. Untung, maka 100*200%*{amount}%={total}U masuk hadiah hari itu",
    yxmgksd: "Setiap order rugi {amount}%= jumlah rugi * {amount}%",
    yhqqksd: "Contoh: Order opsi pengguna rugi 100U, maka 100*{amount}%={total}U masuk hadiah hari itu",
    daiding: "Tertunda",
    yytz: "Penyesuaian Acara",
    kaiqi: "Buka",
    xhjyjrpm: "Trading Spot Gabung Peringkat",
    drjy: "Trading Hari Ini, Dapat Besok",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/ba.js